import * as policies from '../policies';

const can = (action, role) => {
    return policies[action](role);
};

export default can;
